import TypeSpecimenIcon from "@mui/icons-material/TypeSpecimen";
import LanguageIcon from "@mui/icons-material/Language";

import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { FormattedMessage, useIntl } from "react-intl";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TitleIcon from "@mui/icons-material/Title";
import CommentIcon from "@mui/icons-material/Comment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import WorkIcon from "@mui/icons-material/Work";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

const useBasicInfoItems = () => {
  const icons = {
    TypeSpecimenIcon,
    LanguageIcon,
    SchoolIcon,
    AccountBalanceIcon,
    StarBorderIcon,
    CardGiftcardIcon,
    HowToRegIcon,
    WhereToVoteIcon,
    MarkChatUnreadIcon,
    HelpOutlineIcon,
    AttachMoneyIcon,
    TitleIcon,
    CategoryOutlinedIcon,
    LocationCityOutlinedIcon,
    CommentIcon,
    AssessmentIcon,
    CorporateFareIcon,
    WorkIcon,
    AutoStoriesIcon,
  };

  const basicInfoItems = {
    id: "group-basicInfo",
    title: (
      <FormattedMessage id="Site Parameters">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.CategoryOutlinedIcon,
    // url: "/categories",
    type: "group",
    children: [
      {
        id: "categories",
        title: <FormattedMessage id="Categories" />,
        type: "item",
        url: "/categories",
        icon: icons.CategoryOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "countries",
        title: <FormattedMessage id="Countries" />,
        type: "item",
        url: "/countries",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      ,
      {
        id: "job-types",
        title: <FormattedMessage id="Job Types" />,
        type: "item",
        url: "/jobtypes",
        icon: icons.TypeSpecimenIcon,
        breadcrumbs: false,
      },
      {
        id: "job-avarege",
        title: <FormattedMessage id="Job Availabilities" />,
        type: "item",
        url: "/jobavailabilities",
        icon: icons.HowToRegIcon,
        breadcrumbs: false,
      },
      {
        id: "degree",
        title: <FormattedMessage id="Degrees Types" />,
        type: "item",
        url: "/degree",
        icon: icons.StarBorderIcon,
        breadcrumbs: false,
      },

      {
        id: "educational",
        title: <FormattedMessage id="Educational Institutions" />,
        type: "item",
        url: "/educational",
        icon: icons.SchoolIcon,
        breadcrumbs: false,
      },

      {
        id: "language",
        title: <FormattedMessage id="Languages" />,
        type: "item",
        url: "/language",
        icon: icons.LanguageIcon,
        breadcrumbs: false,
      },
      {
        id: "skills",
        title: <FormattedMessage id="Skills" />,
        type: "item",
        url: "/skills",
        icon: icons.CardGiftcardIcon,
        breadcrumbs: false,
      },
      {
        id: "bannerplace",
        title: <FormattedMessage id="Banner Places" />,
        type: "item",
        url: "/bannerplace",

        icon: icons.WhereToVoteIcon,
        breadcrumbs: false,
      },
      {
        id: "question",
        title: <FormattedMessage id="Questions" />,
        type: "item",
        url: "/question",

        icon: icons.HelpOutlineIcon,
        breadcrumbs: false,
      },
      {
        id: "currency",
        title: <FormattedMessage id="Currency" />,
        type: "item",
        url: "/currency",

        icon: icons.AttachMoneyIcon,
        breadcrumbs: false,
      },
      {
        id: "titles",
        title: <FormattedMessage id="Titles" />,
        type: "item",
        url: "/titles",
        icon: icons.TitleIcon,
        breadcrumbs: false,
      },
      {
        id: "bank",
        title: <FormattedMessage id="Banks" />,
        type: "item",
        url: "/bank",
        icon: icons.AccountBalanceIcon,
        breadcrumbs: false,
      },
      {
        id: "comment-action",
        title: <FormattedMessage id="Comment Actions" />,
        type: "item",
        url: "/comment-action",
        icon: icons.CommentIcon,
        breadcrumbs: false,
      },
      {
        id: "report-candidate",
        title: <FormattedMessage id="Report Candidate" />,
        type: "item",
        url: "/report-candidate",
        icon: icons.AssessmentIcon,
        breadcrumbs: false,
      },
      {
        id: "replytoapplicant",
        title: <FormattedMessage id="Reply To Candidate" />,
        type: "item",
        url: "/reply-to-applicant",
        icon: icons.MarkChatUnreadIcon,
        breadcrumbs: false,
      },
      {
        id: "mail-templates",
        title: <FormattedMessage id="Email Templates" />,
        type: "item",
        url: "/mail-templates",
        icon: icons.AssessmentIcon,
        breadcrumbs: false,
      },
      {
        id: "admin-resume-note-type",
        title: <FormattedMessage id="Resume Note Types" />,
        type: "item",
        url: "/admin-resume-note-type",
        icon: icons.AssessmentIcon,
        breadcrumbs: false,
      },
      {
        id: "translations",
        title: <FormattedMessage id="Translations" />,
        type: "item",
        url: "/translations",
        icon: icons.AssessmentIcon,
        breadcrumbs: false,
      },
      {
        id: "company-activities",
        title: <FormattedMessage id="Company Activities" />,
        type: "item",
        url: "/company-activities",
        icon: icons.CorporateFareIcon,
        breadcrumbs: false,
      },
      {
        id: "job-activities",
        title: <FormattedMessage id="Job Activities" />,
        type: "item",
        url: "/job-activities",
        icon: icons.WorkIcon,
        breadcrumbs: false,
      },
      {
        id: "course-categories",
        title: <FormattedMessage id="Course Categories" />,
        type: "item",
        url: "/course-categories",
        icon: icons.AutoStoriesIcon,
        breadcrumbs: false,
      },
      {
        id: "comment-actions",
        title: <FormattedMessage id="comment-actions" />,
        type: "item",
        url: "/comment-actions",
        icon: icons.AutoStoriesIcon,
        breadcrumbs: false,
      },
    ],
  };

  return basicInfoItems;
};

export default useBasicInfoItems;
